<template>
    <div>
        <div class="row mb-4">
            <div class="col-12">
                <ul class="nav nav-pills nav-fill bg-white p-2 shadow-sm rounded-lg border" role="tablist">
                    <li class="nav-item mr-2">
                        <a class="nav-link active py-3" id="v-pills-presion-tab" data-toggle="pill" href="#v-pills-presion" role="tab" @click="activeTab = 'presion'">
                            <i class="fas fa-heartbeat mr-2"></i> P. Arterial
                        </a>
                    </li>
                    <li class="nav-item mr-2">
                        <a class="nav-link py-3" id="v-pills-temperatura-tab" data-toggle="pill" href="#v-pills-temperatura" role="tab" @click="activeTab = 'temperatura'">
                            <i class="fas fa-thermometer-half mr-2"></i> Temperatura
                        </a>
                    </li>
                    <li class="nav-item mr-2">
                        <a class="nav-link py-3" id="v-pills-pulso-tab" data-toggle="pill" href="#v-pills-pulso" role="tab" @click="activeTab = 'pulso'">
                            <i class="fas fa-wave-square mr-2"></i> Pulso
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link py-3" id="v-pills-respiracion-tab" data-toggle="pill" href="#v-pills-respiracion" role="tab" @click="activeTab = 'respiracion'">
                            <i class="fas fa-wind mr-2"></i> Respiración
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="tab-content">
                    <div class="tab-pane fade show active" id="v-pills-presion" role="tabpanel">
                        <PresionArterial v-if="activeTab === 'presion'" :idHistoria="idHistoria" />
                    </div>
                    <div class="tab-pane fade" id="v-pills-temperatura" role="tabpanel">
                        <Temperatura v-if="activeTab === 'temperatura'" :idHistoria="idHistoria" />
                    </div>
                    <div class="tab-pane fade" id="v-pills-pulso" role="tabpanel">
                        <Pulso v-if="activeTab === 'pulso'" :idHistoria="idHistoria" />
                    </div>
                    <div class="tab-pane fade" id="v-pills-respiracion" role="tabpanel">
                        <Respiracion v-if="activeTab === 'respiracion'" :idHistoria="idHistoria" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PresionArterial from './PresionArterial.vue';
import Temperatura from './Temperatura.vue';
import Pulso from './Pulso.vue';
import Respiracion from './Respiracion.vue';

export default {
    props: ['idHistoria'],
    data() {
        return {
            activeTab: 'presion'
        }
    },
    components: {
        PresionArterial,
        Temperatura,
        Pulso,
        Respiracion
    }
}
</script>

<style scoped>
.nav-pills .nav-link {
    background-color: #fff;
    color: #4e73df;
    border: 1px solid #e3e6f0;
}
.nav-pills .nav-link.active {
    background-color: #4e73df;
    color: #fff;
    border-color: #4e73df;
}
</style>
